import React from 'react';
import { Typography } from 'fronton-react';

type TProps = {
  productId: string | undefined;
};

export const ProductArticle = ({ productId }: TProps) => (
  <>
    {productId ? (
      <div data-testid="product-article">
        <Typography size="caption" variant="minor" color="text-minor">
          Арт.
        </Typography>
        <Typography size="caption" variant="minor" color="text-minor">
          {` ${productId}`}
        </Typography>
      </div>
    ) : null}

    {
      // расскоментить когда будем получать вес товара
      /* <Typography size="caption" variant="minor" color="text-primary">
            •
          </Typography>
          <div>
            <Typography size="caption" variant="minor" color="text-primary">
              Вес –
            </Typography>
            <Typography size="caption" variant="minor" color="text-secondary">
              100,1 кг
            </Typography>
          </div> */
    }
  </>
);
